// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const allArraysAreEmpty = (obj: Record<string, any>): boolean =>
  Object.values(obj).reduce((curr, prop) => {
    if (!Array.isArray(prop)) {
      return true
    }

    return curr && !prop.length
  }, true)
